import { makeStyles } from '@mui/styles' // contained "fade" as well before v5
import { Theme, alpha } from '@mui/material/styles'

export const drawerStyles = (drawerOpen: boolean) => {
  return makeStyles((theme: Theme) => ({
    customIcon: {
      width: '100%',
      height: '100%',
    },
    drawer: {
      height: '100vh',
      maxHeight: '100vh',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      overflowX: 'hidden',
      overflow: 'auto',
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      overflowX: 'hidden',
      display: 'flex', // <--- this causes heavy animation lag
      flexDirection: 'column', // <--- this causes heavy animation lag
    },
    drawerPaperSmall: {
      width: theme.custom?.drawerWidthSmall,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    drawerPaperLarge: {
      width: theme.custom?.drawerWidthLarge,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarDrawerOpen: {

    },
    appBarDrawerClosed: {
      width: 0,
    },
    listSubheader: {
      background: 'linear-gradient(180deg, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%)',
      pointerEvents: 'none',
      fontSize: theme.spacing(1.5),
      height: theme.spacing(6), // height equals line-height
      opacity: 1,
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(3.75),
      transition: theme.transitions.create(['height', 'opacity'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    listSubheaderHidden: {
      height: 0,
      opacity: 0,
      transition: theme.transitions.create(['height', 'opacity'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    listIcon: {
      minWidth: 0,
    },
    list: {
      marginBottom: theme.spacing(3),
    },
    listItem: {
      position: 'relative',
      padding: drawerOpen ? '' : '10px 30px',
      borderRadius: drawerOpen ? '' : '50px',
      '& .MuiListItemText-root': {
        textIndent: drawerOpen ? '200px' : '',
      },
      '&:last-child': {
        '&::after': {
          content: "''",
          display: drawerOpen ? 'none' : 'block',
          position: 'absolute',
          width: '85%',
          bottom: 0,
          borderBottom: '1px solid',
          marginLeft: '-10px',
        },
      },
      '&::before': {
        content: "''",
        display: drawerOpen ? 'none' : 'block',
        position: 'absolute',
        width: '85%',
        top: 0,
        borderTop: '1px solid',
        marginLeft: '-10px',
      },
      '&:hover': {
        border: 'none',
        textTransform: 'inherit',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.main,
        '& .MuiListItemIcon-root': {
          color: theme.palette.common.white,
        },
        '& svg path': {
          fill: theme.palette.common.white,
        },
        '&::before': {
          display: 'none',
        },
        '& + .MuiListItem-root': {
          '&::before': {
            display: 'none',
          },
        },
        '&:last-child': {
          '&::after': {
            display: 'none',
          },
        },
      },
      '&.Mui-selected, &.Mui-selected:hover': {
        border: 'none',
        textTransform: 'inherit',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.main,
        '& .MuiListItemIcon-root': {
          color: theme.palette.common.white,
        },
        '& svg path': {
          fill: theme.palette.common.white,
        },
        '&::before': {
          display: 'none',
        },
        '&:last-child': {
          '&::after': {
            display: 'none',
          },
        },
        '& + .MuiListItem-root': {
          '&::before': {
            display: 'none',
          },
        },
      },
    },
    drawerContent: {
      flex: 1,
      padding: drawerOpen ? '' : '45px 12px 12px',
      overflowY: 'auto',
      overflowX: 'hidden',
    },

    drawerBackdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      background: `linear-gradient(
      60deg,
      ${alpha(theme.palette.secondary.main, 0.85)},
      ${alpha(theme.palette.primary.main, 0.85)} 40%,
      ${alpha(theme.palette.primary.main, 0.85)} 60%,
      ${alpha(theme.palette.secondary.main, 0.85)} 100%
      )`,
      backgroundSize: '300% 100%',
      animation: '$diagonalAnimation alternate 45s infinite',
    },
    '@keyframes diagonalAnimation': {
      '0%': {
        backgroundPosition: '0% 50%',
      },
      '50%': {
        backgroundPosition: '100% 50%',
      },
      '100%': {
        backgroundPosition: '0% 50%',
      },
    },
  }))
}
